module.exports = __webpack_public_path__ + "static/media/icon-booth-rev-charity.c83cbf30.svg";